import { render } from "./ViewRichBlock.vue?vue&type=template&id=15225983&scoped=true"
import script from "./ViewRichBlock.vue?vue&type=script&lang=js"
export * from "./ViewRichBlock.vue?vue&type=script&lang=js"

import "./ViewRichBlock.vue?vue&type=style&index=0&id=15225983&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15225983"]])

export default __exports__